module.exports = __webpack_public_path__ + "static/media/sud_add.931169ad.png";